
export default function ValuesSection() {
  const values = [
    {
      icon: 'ri-focus-2-line',
      title: 'Results-Driven',
      description: 'Every decision we make is focused on driving measurable results for your business. We track, optimize, and improve until we achieve your goals.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Client-First Approach',
      description: 'Your success is our success. We work as an extension of your team, providing dedicated support and strategic guidance every step of the way.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation & Creativity',
      description: 'We stay ahead of industry trends and continuously innovate our approaches to ensure your funnels outperform the competition.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Quality Assurance',
      description: 'We deliver nothing but the highest quality work. Every funnel is thoroughly tested and optimized before launch.'
    },
    {
      icon: 'ri-time-line',
      title: 'Timely Delivery',
      description: 'We respect your time and deadlines. Our streamlined processes ensure projects are completed on schedule without compromising quality.'
    },
    {
      icon: 'ri-group-line',
      title: 'Transparency',
      description: 'Clear communication, honest feedback, and transparent reporting. You always know exactly what we\'re working on and why.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Our Core Values
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            These principles guide everything we do and define how we work with our clients
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${value.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{value.title}</h3>
              <p className="text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}